/**
 * @param {Array<{ x: number, y: number }>} points
 * @returns
 */
function polygonArea(points) {
  let area = 0;
  const n = points.length;

  for (let i = 0; i < n; i++) {
    const j = (i + 1) % n;
    area += points[i].x * points[j].y - points[j].x * points[i].y;
  }

  return Math.abs(area) / 2;
}

export default polygonArea;
